import {loadModules} from "esri-loader";
import { ledgerFormUrl, origin } from "@/config";
export default {
    data () {
        return {
            loading: false,
            formId: '', // 表单id，子应用需要使用此id请求配置相关信息，注册时会被复写
            microAppName: 'ledgerConfig', // 微服务名称，多个微服务确保唯一性 注册时会复写为菜单地址
            ledgerFormUrl,
            ledgerFormRoute: '/ledger-form-page',
            type: 'loading'
        }
    },
    created() {
        this.checkGisModuleIsLoad()
        this.loading = true
        this.$microApp.addDataListener(this.microAppName, () => { this.loading = false }, false)
    },
    beforeDestroy() {
        this.loading = false
        this.$microApp.clearDataListener(this.microAppName)
    },
    methods: {
        microAppCreated () {
            this.type = 'update'
        },
        microAppMounted () {
            this.type = 'loading'
        },
        checkGisModuleIsLoad () {
            if (!window.define) { // 使用微服务时，子应用内部包含gis相关脚本文件，模块化解析会滞后，这里对gis脚本预加载一次，防止出现异常
                loadModules([], { url: `${origin}/js.arcgis.com/arcgis4.16/dojo/dojo.js` })
            }
        }
    }
}
